<template>
    <div id="blog-element" :class="{empty: !moduleData}">
        <div class="module" v-if="moduleData" :class="moduleData.Spacing" :id="moduleData.AnchorID">
            <div class="blog-categorization" v-if="moduleData.ShowFilters">
                <div class="container">
                    <div class="left">
                        <div v-if="categories.length > 1">
                            <label for="category-filter">Category</label>
                            <v-select id="category-filter"
                                      v-model="selectedCategory"
                                      :options="categories"
                                      :clearable="false"
                                      placeholder="All Categories">
                            </v-select>
                        </div>
                        <div>
                            <label>Date</label>
                            <date-range-picker
                                opens="center"
                                :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY' }"
                                v-model="selectedDates"
                                :timePicker="false"
                                :timePicker24Hour="false"
                                :autoApply="true"
                            >
                                <template v-slot:input="picker">
                                    <span v-if="picker.startDate">{{ picker.startDate | date }} - {{ picker.endDate | date }}</span>
                                    <span v-else>All Dates</span>
                                </template>
                            </date-range-picker>
                        </div>
                    </div>
                    <div class="right">
                        <p>{{posts.length}} Items</p>
                        <div>
                            <label for="product-sort">Sort</label>
                            <v-select id="product-sort"
                                      v-model="selectedSort"
                                      :options="['Most Recent', 'Alphabetical']"
                                      :clearable="false">
                            </v-select>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container">
                <h2 v-if="moduleData.Title && moduleData.ShowTitle">{{moduleData.Title}}</h2>
                <b-row>
                    <b-col class="blog-post" md="6" lg="4" v-for="(post, index) in paginatedPosts" :key="'post' + index"
                           :style="'--animation-order:' + index">
                        <div class="post-holder">
                            <a :href="post.Link">
                                <b-img v-if="post.ResampledImage" v-bind="imageProps" :src="post.ResampledImage"></b-img>
                                <div class="post-content">
                                    <p class="publish">{{post.PublishedDate}}</p>
                                    <p class="heading">{{post.Title}}</p>
                                    <p class="content">{{post.PlainSummary}}</p>
                                </div>
                            </a>
                        </div>
                    </b-col>
                </b-row>
                <button class="btn btn-dark" v-if="showLoadMore" @click="page += 1">More Story</button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import DateRangePicker from 'vue2-daterange-picker';
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
    import moment from 'moment';

    export default {
        name: "BlogElement",
        data() {
            return {
                imageProps: {
                    center: true
                },
                page: 1,
                selectedSort: 'Most Recent',
                selectedCategory: null,
                selectedDates: {
                    startDate: null, endDate: null
                },
            }
        },
        filters: {
            date(val) {
                return val ? moment(val).format("YYYY-MM-DD") : "";
            }
        },
        components: {DateRangePicker},
        props: {
            component: {
                type: Object,
            }
        },
        computed: {
            ...mapGetters(['getModuleData']),
            moduleData() {
                return this.getModuleData(this.component.ID);
            },
            posts() {
                return this.moduleData.Posts.BlogPosts;
            },
            categories() {
                return this.moduleData.Posts.Categories;
            },
            filteredPosts() {
                let posts = this.posts;

                if (this.selectedCategory && this.selectedCategory !== 'All Categories') {
                    posts = posts.filter(p => {
                        if (p.CategoryIndex) {
                            return p.CategoryIndex.toLowerCase().includes(this.selectedCategory.toLowerCase());
                        }
                    })
                }

                if (this.selectedCategory && this.selectedCategory !== 'All Categories') {
                    posts = posts.filter(p => {
                        if (p.CategoryIndex) {
                            return p.CategoryIndex.toLowerCase().includes(this.selectedCategory.toLowerCase());
                        }
                    });
                }

                if (this.selectedDates.startDate) {
                    let dateFrom = moment(this.selectedDates.startDate);
                    posts = posts.filter(p => {
                        if (p.PublishDate) {
                            if (p.PublishDate) {
                                return moment(p.PublishDate).isAfter(dateFrom);
                            }
                        }
                    });
                }

                if (this.selectedDates.endDate) {
                    let dateTo = moment(this.selectedDates.endDate);
                    posts = posts.filter(p => {
                        if (p.PublishDate) {
                            if (p.PublishDate) {
                                return moment(p.PublishDate).isBefore(dateTo);
                            }
                        }
                    });
                }

                if (this.selectedSort === 'Most Recent') {
                    posts = posts.sort((a, b) => (a.PublishDate < b.PublishDate) ? 1 : -1);
                } else if (this.selectedSort === 'Alphabetical') {
                    posts = posts.sort((a, b) => (a.Title > b.Title) ? 1 : -1);
                }

                return posts;
            },
            paginatedPosts() {
                let limit = this.pageSize * this.page;
                return this.filteredPosts.slice(0, limit);
            },
            pageSize() {
                return parseFloat(this.moduleData.PageSize) > 0 ? parseFloat(this.moduleData.PageSize) : 3;
            },
            showLoadMore() {
                let limit = this.pageSize * this.page;
                return limit < this.filteredPosts.length;
            }
        }
    }
</script>

